// Short-lived (~5 min) download token used in `?auth=` query params on
// file/PDF download URLs. SEC-003: keeps the 7-day access JWT out of
// browser history, proxy logs, and Referer headers.
//
// The token is fetched lazily on first use and cached in module state.
// Callers should `await ensureDLToken()` before composing a URL; the
// sync `getDLToken()` returns whatever is currently cached (may be "").

import api from "./api";

let cached = { token: "", expiresAt: 0, inflight: null };

// Refresh ~30 s before the server-side expiry so a slow click still fires
// with a valid token. Backend ttl is 300 s.
const REFRESH_BEFORE_EXPIRY_MS = 30_000;

export function getDLToken() {
  return cached.token;
}

export async function ensureDLToken() {
  const now = Date.now();
  if (cached.token && now < cached.expiresAt - REFRESH_BEFORE_EXPIRY_MS) {
    return cached.token;
  }
  if (cached.inflight) return cached.inflight;
  cached.inflight = api
    .post("/auth/download-token")
    .then(({ data }) => {
      cached = {
        token: data.token,
        expiresAt: Date.now() + (data.expires_in || 300) * 1000,
        inflight: null,
      };
      return cached.token;
    })
    .catch((e) => {
      cached.inflight = null;
      throw e;
    });
  return cached.inflight;
}

export function clearDLToken() {
  cached = { token: "", expiresAt: 0, inflight: null };
}

// Build `?auth=<token>` (or append `&auth=...` if URL already has params).
export function appendDLAuth(url) {
  const t = cached.token;
  if (!t) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}auth=${encodeURIComponent(t)}`;
}
